import React, { useEffect, useState } from "react";
import { EventLayer } from "./event-layer";
import { Icon } from "@iconify/react";
import { useTranslationsById } from "../../../../hooks/use-translations-by-id";
import { useLanguage } from "../../../../hooks/use-language";

/**
 * Vista secundaria para compartir o copiar el enlace de un evento.
 */
export const Share = ({ link, description, visible, setVisible }) => {
	const lang = useLanguage();
	const texts = useTranslationsById({ mainSectionName: "reading_resources", language: lang });

	const [copied, setCopied] = useState(false);

	useEffect(() => {
		return () => {
			setCopied(false);
		};
	}, [visible, setVisible]);

	const copyLink = (value) => {
		try {
			navigator.clipboard.writeText(value);
			setCopied(true);
		} catch (err) {
			console.error("Error copying link: ", value, err);
		}
	};

	return (
		<EventLayer
			title={texts.getText({
				id: "makemake_en_vivo.evento.boton.compartir",
				defaultText: "Share",
			})}
			visible={visible}
			setVisible={setVisible}
		>
			<div className="share d-flex w-100 flex-column flex-grow-1">
				<p className="onbackground-color my-2">{description || "N/A"}</p>
				<div className="w-100 d-flex flex-nowrap align-items-center">
					<input
						className="input p-2 form-control ondisabled-color--bg disabled-color--color focusable-secondary"
						value={link}
						readOnly
						aria-label={texts.getText({
							id: "makemake_en_vivo.evento.compartir.input.aria",
							defaultText: "Event link to copy",
						})}
						contentEditable={false}
						onClick={() => copyLink(link)}
						onKeyDown={() => copyLink(link)}
						onKeyUp={() => copyLink(link)}
					/>
					<button
						className="focusable-red copy-button"
						onClick={() => copyLink(link)}
						aria-label={texts.getText({
							id: "makemake_en_vivo.evento.compartir.copy_button.aria",
							defaultText: "Copy event link",
						})}
					>
						<Icon icon="solar:copy-bold" width={40} />
					</button>
				</div>
				{copied ? (
					<p className="font-weight-bold green-inverse--color text-center my-2">
						{texts.getText({
							id: "makemake_en_vivo.evento.compartir.copiado",
							defaultText: "Link copied!",
						})}
					</p>
				) : null}
			</div>
		</EventLayer>
	);
};
